import { ApiRequestFilters } from '../../../shared/types/api-request-filters';
import { AssetTypeEnum } from '../enums/asset-type.enum';

/**
 * Assets filters
 */
export class AssetsFilters extends ApiRequestFilters {
	/**
	 * Type filters
	 */
	types?: AssetTypeEnum[];

	/**
	 * Vehicle group UUID filters
	 */
	vehicleGroupUuids?: string[];

	/**
	 * Feature items filters with key-value pairs
	 */
	featureItems?: { key: string; value: string }[];
}
